import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute,Params } from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';


@Component({
  selector: 'app-user-bookmarks',
  templateUrl: './user-bookmarks.component.html',
  styleUrls: ['./user-bookmarks.component.css'],

})
export class UserBookmarksComponent implements OnInit {

  public mybookmarkList:any;
  public mybookmarkpostId:any=[];
  msg:String="";
  bookmarkType:any='blank';
  formoption:any;
 

  constructor(private router:Router, private route: ActivatedRoute) { 
    this.mybookmarkList=[];

    this.route.params.subscribe((params: Params) => {
      this.bookmarkType = params['id'];
      this.formoption={createpost:false,bookmarkType:this.bookmarkType}
    });
  }

  ngOnInit() {
      //this.getMyBookmark();
  }

  
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/user-bookmarks/user-bookmarks.component.ts